'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var data = _ref.data,
        error = _ref.error,
        warning = _ref.warning;

    if (!(0, _isObject2.default)(data)) {
        error(getMessage('Data is not an object'));
    }

    // headers

    if (!(0, _isArray2.default)(data.headers)) {
        error(getMessage('Response headers is not an array'));
    }

    if (!data.headers.length > 1) {
        error(getMessage('At least two response headers required'));
    }

    data.headers.forEach(function (header) {
        return validateHeader(header, error);
    });

    // meta data

    if (!(0, _isObject2.default)(data.metaData)) {
        error(getMessage('Metadata is not an object'));
    }

    if (!(0, _isObject2.default)(data.metaData.items)) {
        error(getMessage('Metadata items is not an object'));
    }

    if (!(0, _isObject2.default)(data.metaData.dimensions)) {
        error(getMessage('Metadata dimensions is not an object'));
    }

    // data

    if (!(0, _isArray2.default)(data.rows)) {
        warning(getMessage('Data rows is not an array'));
    }

    if (!data.rows.length) {
        warning(getMessage('No data rows provided'));
    }

    data.rows.forEach(function (row) {
        return validateRow(row, data.headers.length, error);
    });

    return data;
};

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE = 'Data validator: ';

function getMessage(text) {
    return MODULE + text;
}

function validateHeader(header, error) {
    if (!(0, _isObject2.default)(header)) {
        error(getMessage('Header is not an object'));
    }

    if (header.meta) {
        if (!(0, _isString2.default)(header.name)) {
            error(getMessage('Header name is not a string'));
        }
    }
}

function validateRowValue(rowValue, error) {
    if (!(0, _isString2.default)(rowValue)) {
        error(getMessage('Row value is not a string'));
    }
}

function validateRow(row, headersLength, error) {
    if (!(0, _isArray2.default)(row)) {
        error(getMessage('Data row is not an array'));
    }

    if (row.length !== headersLength) {
        error(getMessage('Data row length is invalid'));
    }

    row.forEach(function (rowValue) {
        return validateRowValue(rowValue, error);
    });
}
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/store/validators/dhis/index.js
 ** module id = 225
 ** module chunks = 0 1
 **/